import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle,Grid,Icon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typo from './CustomTypo'
import { CloseIcon } from './icons';
const styles = theme => ({
    dialogTitle :{
        backgroundColor:theme.palette.primary.main,
        padding: theme.spacing(2)
    },
    right:{
        float:'right',
        textAlign:'right'
    },
    closeModal:{
        color:theme.palette.primary.contrastText
    },
    action:{
        marginTop:theme.spacing(4),
        marginBottom:theme.spacing(4),
        justifyContent: 'center'
    },
    paperScrollPaper:{
        maxHeight: 'calc(100% - 10px)',
        [theme.breakpoints.down('md')]: {
            margin:theme.spacing(2),
            // zIndex:1350
        },
    },
    // dialogRoot:{
    //     [theme.breakpoints.down('md')]: {
    //         zIndex:1350
    //     },
    // },
    dialogContentRoot:{
        // textAlign:'center',
        [theme.breakpoints.down('md')]: {
            padding:theme.spacing(2),
        },
    },
    cssTitle: {
        display: 'flex',
        alignItems: 'center',
    }
});
class Modal extends React.Component {
    state = {
        open: false,
    };


    render() {
        const {classes,open,onClose,maxWidth,hideHeader,title,content,action,children,contentStyle,hideClose,...rest} = this.props
        return (
            <div>
                <Dialog
                    open={open===undefined ? false : open}
                    onClose={(event, reason) => {
                        if(reason !== 'backdropClick' && reason !== 'escapeKeyDown')
                            onClose();
                    }}
                    aria-labelledby="form-dialog-title"
                    maxWidth={maxWidth}
                    fullWidth={true}
                    // disableBackdropClick={true}
                    classes={{root:classes.dialogRoot,paperScrollPaper : classes.paperScrollPaper}}
                    {...rest}
                >
                {hideHeader ? undefined :  
                    <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
                        <Grid container direction='row'>
                            <Grid item xs={10} className={classes.cssTitle}>
                                <Typo type="title" color='onPrimary'>{title}</Typo>
                            </Grid>
                            {!hideClose && <Grid item xs={2} className={classes.right} onClick={this.props.onClose}>
                                <Icon style={{cursor:'pointer'}} className={classes.closeModal}>
                                    <CloseIcon/>
                                </Icon>
                            </Grid>}
                        </Grid>
                    </DialogTitle> }
                    <DialogContent className={contentStyle ? contentStyle : classes.dialogContentRoot}>
                        {content ? content : children}
                    </DialogContent>
                    {action && <DialogActions className={classes.action}>
                        {action}
                    </DialogActions>}
                </Dialog>
            </div>
        );
    }
}
export default withStyles(styles)(Modal);